import { useQuery, useQueries } from "@tanstack/react-query";

import {
  getVideoUserGuides,
} from "../../../services/userGuideService";
import { recordError } from "../../../utils/logService";
import { QUERY_DEFAULTS, STALE_INTERVAL } from "../utils/constants";

export const useVideoGuides = (moduleName) => {
  const results = useQueries({
    queries: [
      {
        ...QUERY_DEFAULTS,
        staleTime: STALE_INTERVAL.DEFAULT,
        queryKey: ["user-guides-videos", moduleName],
        queryFn: () => getVideoUserGuides(moduleName),
        onError: (error) => recordError(error),
      },
    ],
  });

  return {
    videoGuideList: results[0],
  };
}   